module.exports = __webpack_public_path__ + "static/img/user2.306ec89.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/public/user2.png
// module id = z4YW
// module chunks = 90